import { Account } from '@libs/src/models/account.model';
import { USER_ONBOARDING_ROUTE_PATHS } from '@main-client/src/app/user-onboarding/user-onboarding.helper';
import { filterVisibleGroups } from '@main-client/src/app/user/user.helpers';

import get from 'lodash-es/get';

export const LINKEDIN_API_URL = '/api/social-auth/linkedin';

export const LINKEDIN_OAUTH_CONFIG = {
  url: LINKEDIN_API_URL,
  authorizationEndpoint: 'https://www.linkedin.com/oauth/v2/authorization',
  scope: ['r_emailaddress', 'r_liteprofile'],
  requiredUrlParams: ['state', 'scope'],
  state: 'oauth2-redirect',
};

export function getNewAccountRedirectParams(
  userProfile: Account,
  groupId?: string,
) {
  const userGroups = get(userProfile, 'groups', []);
  const userGroupMemberships = filterVisibleGroups(userGroups);
  const firstGroupId =
    (1 <= get(userGroupMemberships, 'length', 0) &&
      get(userGroupMemberships, '[0].document._id')) ||
    null;
  const onboardingPath = firstGroupId
    ? USER_ONBOARDING_ROUTE_PATHS.hubSegments
    : USER_ONBOARDING_ROUTE_PATHS.hubs;
  return {
    path: ['/get-started', onboardingPath],
    queryParams: { preregistrationGroupId: groupId || firstGroupId },
  };
}
